module.exports = __webpack_public_path__ + "media/images/veritrans_payment/Card_Diners-df7f9072c9a33defd0eb9b4f0981becd.gif";